module.exports = __webpack_public_path__ + "img/mgmt_logo_small.e85386c4.svg";